module.exports = __webpack_public_path__ + "img/Logo-mob.9cc7855d.svg";